import { deleteToken } from '../services/tokenSlice';
import { removePopup as removePopupAction } from '../services/features/popupSlice';
import {
  useAppDispatch,
  useAppSelector,
} from '../storeHook';
import { CustomDialog } from './CustomDialog';
import { useMsal } from '@azure/msal-react';
import { resetAuthUser } from '../services/features/authUserSlice';

export const AppPopup = () => {
  const { showPopup, title, desc, actionText } =
    useAppSelector((state) => state.popup);
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const removePopup = () => {
    dispatch(removePopupAction());
  };
  const handleOnSubmitAction = () => {
    instance
      .logoutRedirect({
        onRedirectNavigate: () => {
          // Return false if you would like to stop navigation after local logout
          return false;
        },
      })
      .then(() => {});

    localStorage.removeItem('authToken');
    sessionStorage.removeItem('pageReloaded');
    localStorage.removeItem('screen_url');
    dispatch(resetAuthUser());
    dispatch(deleteToken());
    window.location.reload();
  };

  const onSubmit = () => {
    removePopup();
    handleOnSubmitAction();
  };

  return (
    <CustomDialog
      dialogTitle={title}
      open={showPopup}
      setOpen={removePopup}
      onSubmit={onSubmit}
      actionText={actionText}
      maxWidth="sm"
      closeButton={false}
      showOnlyAccept={true}>
      <div>{desc}</div>
    </CustomDialog>
  );
};
